//Return the dates
export const getDMADate = (data: any) => { console.log(data); return data[0][Object.keys(data[0]).toString()].consumption.dates; }
